function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 21 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19.34 3.7v19.36a.5.5 0 01-.753.431l-8.013-4.686a2.5 2.5 0 00-1.262-.342H4.395a2.5 2.5 0 01-2.5-2.5v-2.71h0v-2.55a2.5 2.5 0 012.545-2.5l4.835.089a2.5 2.5 0 001.307-.342l8.005-4.681a.5.5 0 01.753.432z",
  stroke: "#EFEFEF",
  strokeWidth: "3"
})));